import { getStorage } from '@src/utils/enhancedStorage'

export const eraseFromLocalStorage = (key: string) => {
  getStorage().removeItem(key)
}
